import { BirthDatePicker as BirthDatePickerRc } from '@pba/react-components';
import type { ComponentProps } from 'react';
import { Select } from '../../select';

type BirthDatePickerProperties = ComponentProps<typeof BirthDatePickerRc>;

const BirthDatePicker = (props: BirthDatePickerProperties) => <BirthDatePickerRc Select={Select} {...props} />;

export default BirthDatePicker;
